// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-43d59336] .q-field__native{text-align:center}[data-v-43d59336] .q-select .q-field__input{text-align:center}[data-v-43d59336] .q-field--standout.q-field--highlighted .q-field__native{text-align:center}label[data-v-43d59336]{width:220px}[data-v-43d59336] .q-field__native{font-size:14px!important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
